import FactureLigneModel from "./FactureLigneModel";
import UserModel from "./UserModel";

class FactureModel {
    constructor(data) {
        this.id = data.id || null;
        this.user_id = data.user_id || null;
        this.client_id = data.client_id || null;
        this.devis_id = data.devis_id || null;

        this.numero = data.numero || null;
        this.date_emission = data.date_emission || null;
        this.date_echeance = data.date_echeance || null;
        this.statut = data.statut || "brouillon";

        this.titre = data.titre || null;
        this.notes_client = data.notes_client || null;
        this.notes_internes = data.notes_internes || null;

        this.sous_total_centimes = data.sous_total_centimes || 0;
        this.remise_centimes = data.remise_centimes || 0;
        this.tva_centimes = data.tva_centimes || 0;
        this.total_centimes = data.total_centimes || 0;

        this.acompte_centimes = data.acompte_centimes || 0;
        this.reste_du_centimes = data.reste_du_centimes || 0;

        this.type_paiement = data.type_paiement || null; // 'virement', 'cheque', 'espece'
        this.devise = data.devise || "EUR";

        // Relations (si backend renvoie les données liées)
        this.client = data.client || null;
        // console.log("data.user dans FactureModel :", data.user);
        this.user = data.user ? new UserModel(data.user) : null;


        this.devis = data.devis || null;
        this.lignes = data.lignes
            ? data.lignes.map((ligne) => new FactureLigneModel(ligne))
            : [];
        // Nouveaux champs pour les secteurs
        this.secteurs_batiment = data.secteurs_batiment || []; // tableau {id, nom}
        this.secteurs_autres = data.secteurs_autres || [];     // tableau {id, nom}

        this.created_at = data.created_at || null;
        this.updated_at = data.updated_at || null;
        this.deleted_at = data.deleted_at || null;
    }
}

export default FactureModel;
